// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Tiles_accordion__1HPTk","race-name":"Tiles_race-name__1ZT0y","button":"Tiles_button__3VLOv"};